/**
 * Marinovel 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'

export const theme = {
  popupTagBgColor: '#E8EFFF',
  popupTagColor: '#65686F',
  popupTagActiveColor: '#FFFFFF',

  filterBgColor: '#F5F7FB',
  filterActiveBgColor: '#EEF4FF',
  filterColor: '#65686F',
  filterActiveColor: '#2C70FF',
} as const

export const tagsConfig: TagsPageConfig = {
  theme,
  texts: tagsCommonConfig.texts,
}
